import {useDispatch, useSelector} from "react-redux";
import {setTrajectoryStore} from "../../store/entities/trajectory";
import {useDebouncedEffect} from "./UseDebouncedEffect";

export const ChartLoader = props => {
  const dispatch = useDispatch();
  const store = {
    startDate: useSelector(state => state.entities.trajectory.startDate),
    endDate: useSelector(state => state.entities.trajectory.endDate),
    roadWidth: useSelector(state => state.entities.trajectory.roadWidth),
    mileMarkerOffset: useSelector(state => state.entities.trajectory.mileMarkerOffset),
    subtractMileMarkers: useSelector(state => state.entities.trajectory.subtractMileMarkers),
    flipMileMarkers: useSelector(state => state.entities.trajectory.flipMileMarkers),
    waypoints: useSelector(state => state.entities.trajectory.waypoints),
    route: useSelector(state => state.entities.trajectory.route),
    routeName: useSelector(state => state.entities.trajectory.routeName),
    submitClicked: useSelector(state => state.entities.trajectory.submitClicked),
    submitFromURL: useSelector(state => state.entities.trajectory.submitFromURL),
    eventTable: useSelector(state => state.entities.trajectory.eventTable),
    movementTable: useSelector(state => state.entities.trajectory.movementTable)
  }

  useDebouncedEffect(() => {
    let isDev = (window.location.href.match('dev') || !window.location.href.match('appspot'));
    if (store.routeName && isDev) document.title = `DEV ${store.routeName} | Trajectory Heatmap`;
    else if (store.routeName && !isDev) document.title = `${store.routeName} | Trajectory Heatmap`;
    else if (!store.routeName && isDev) document.title = 'DEV Trajectory Heatmap';
    else if (!store.routeName && !isDev) document.title = 'Trajectory Heatmap';
    if (store.submitFromURL || store.submitClicked) {
      if (store.startDate && store.endDate && store.roadWidth && store.route && store.waypoints && store.movementTable) {
        dispatch(setTrajectoryStore({
          submitClicked: false,
          submitFromURL: false
        }));
        props.submitListener();
      }
    }
  }, [store], 500)
  return (
    <div/>
  )
}
